import PocketBase from 'pocketbase';

export const pb = new PocketBase('https://aubergedepeguilhan.infocolab.online');

// Activer le support des cookies pour les requêtes d'authentification
pb.autoCancellation(false);

// Intercepteur pour ajouter le token d'authentification aux requêtes
pb.beforeSend = function (url, options) {
  const token = pb.authStore.token;
  if (token) {
    options.headers = options.headers || {};
    options.headers['Authorization'] = `Bearer ${token}`;
  }
  
  // Supprimer credentials pour éviter les erreurs CORS
  delete options.credentials;
  
  return { url, options };
};

export default pb;
